export enum PortalType {
  PORTAL_V2 = 'PORTAL_V2',
  PORTAL_V3 = 'PORTAL_V3',
}
